import ModelLoader from 'app/scripts/db/model-loader';
import ModelCache from 'app/scripts/db/model-cache';

/**
 * This might seem redundant with ModelCache already doing the caching but
 * ModelCache does not ensure that the Model has all the required fields loaded.
 * This additional layer of caching guarantees that the Card or Board has been
 * loaded by the methods in this file so that it definitely has all the necessary
 * fields for the classic popover hacks we're doing on MBTV.
 */
const idBoardHasBeenLoaded = new Map<string, boolean>();
const idCardhasBeenLoaded = new Map<string, boolean>();

export const fireAndForgetExtraBoardDataLoad = (idBoardOrShortLink: string) => {
  const loadSecondary = ModelLoader.for(
    'top-level',
    'loadBoardSecondary',
    idBoardOrShortLink,
  );
  const loadPluginData = ModelLoader.for(
    'top-level',
    'loadBoardPluginData',
    idBoardOrShortLink,
  );

  return Promise.all([loadSecondary, loadPluginData]);
};

interface LoadBoardDataOptions {
  loadExtraBoardData?: boolean;
}

export const loadBoardData = async (
  idBoardOrShortLink: string,
  { loadExtraBoardData }: LoadBoardDataOptions = {},
) => {
  if (idBoardHasBeenLoaded.get(idBoardOrShortLink)) {
    return ModelCache.get('Board', idBoardOrShortLink);
  }

  const board = await ModelLoader.for(
    'top-level',
    'loadBoardMinimalForDisplayCard',
    idBoardOrShortLink,
  );

  if (loadExtraBoardData) {
    fireAndForgetExtraBoardDataLoad(idBoardOrShortLink);
  }

  idBoardHasBeenLoaded.set(idBoardOrShortLink, true);

  return board;
};

export const getOrLoadCardData = async (idCardOrShortLink: string) => {
  if (idCardhasBeenLoaded.get(idCardOrShortLink)) {
    const card = ModelCache.get('Card', idCardOrShortLink);
    if (card) {
      return card;
    }
  }

  const card = await ModelLoader.for(
    'top-level',
    'loadCardData',
    idCardOrShortLink,
  );

  idCardhasBeenLoaded.set(idCardOrShortLink, true);

  return card;
};
